<div class="cm-paragraph cm-form-paragraph" [ngClass]="{ error: showError }">
  <label *ngIf="label" class="cm-label" [for]="inputId">
    {{ label | translate }}
    <span *ngIf="suggestedValue" (click)="writeValue(suggestedValue)">
      (<span class="input__suggested-value">{{ suggestedValueLabel || suggestedValue }}</span
      >)
    </span>
    <span class="font-normal" *ngIf="infoLabel">{{ infoLabel | translate }}</span>
  </label>

  <div class="cm-input-wrap">
    <ng-content select="[app-input-addons-left]"></ng-content>

    <div class="cm-input-group" [ngClass]="inputGroupClasses">
      <ng-content select="[app-input-addons-left-inside]"></ng-content>

      <input
        #input
        [type]="type"
        class="cm-input"
        [id]="inputId"
        [(ngModel)]="value"
        (focus)="isFocused = true"
        (focusout)="onBlur()"
        (ngModelChange)="onInput()"
        [disabled]="disabled || false"
        [placeholder]="placeholder || '' | translate"
        [attr.autocapitalize]="autocapitalize"
        [attr.data-testid]="testId"
        [attr.name]="name"
      />

      <ng-content select="[app-input-addons-right-inside]"></ng-content>
    </div>

    <ng-content select="[app-input-addons-right]"></ng-content>
  </div>

  <span *ngIf="showError" class="cm-form-error-text">{{ errorMessage || '' | translate }}</span>
  <ng-content></ng-content>
</div>
